module.exports = "<div class=\"input-group datepicker date-picker\">\n  <input type=\"text\" id=\"{{name}}\" name=\"{{name}}\" class=\"form-control input-sm\" uib-datepicker-popup=\"{{format}}\" ng-model=\"ngModel\" is-open=\"opened\" datepicker-options=\"options\" ng-click=\"open($event)\" ng-required=\"{{required}}\" />\n  <span class=\"input-group-btn\">\n    <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"open($event)\">\n      <i class=\"fa fa-calendar\" aria-hidden=\"true\"></i>\n    </button>\n  </span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/directives/datePicker/datePicker.html
// module id = 166
// module chunks = 0